<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">CONTENTS</p>
<p class="toc"><a href="#/Acknowledgements">Acknowledgements</a></p>
<p class="toc"><a href="#/Introduction">Introduction</a></p>
<p class="toc1"><a href="#/Part1">P<span class="small">ART</span> I. P<span class="small">RE</span>-M<span class="small">INNEAPOLIS</span></a></p>
<p class="toc"><a href="#/Part1#S1">The Last Scalp Dance on the Land of Minneapolis</a></p>
<p class="toc"><a href="#/Part1#S2">Man of the Sky’s Decline</a></p>
<p class="toc"><a href="#/Part1#S3">A “Sort of Frenzy”</a></p>
<p class="toc1"><span href="#/Part2" title="Link target outside of Sample">P<span class="small">ART</span> II. E<span class="small">ARLY</span> M<span class="small">INNEAPOLIS</span></span></p>
<p class="toc"><span href="#/Part2#S4" title="Link target outside of Sample">A Cold(-Hearted) June</span></p>
<p class="toc"><span href="#/Part2#S5" title="Link target outside of Sample">Escape from Christmas</span></p>
<p class="toc"><span href="#/Part2#S6" title="Link target outside of Sample">The Bridge Square Fires</span></p>
<p class="toc1"><span href="#/Part3" title="Link target outside of Sample">P<span class="small">ART</span> III. D<span class="small">ARK</span> S<span class="small">ATANIC</span> M<span class="small">ILLS</span></span></p>
<p class="toc"><span href="#/Part3#S7" title="Link target outside of Sample">The Falls Collapse</span></p>
<p class="toc"><span href="#/Part3#S8" title="Link target outside of Sample">The Mill Explosion</span></p>
<p class="toc1"><span href="#/Part4" title="Link target outside of Sample">P<span class="small">ART</span> IV. V<span class="small">IOLENCE IN THE</span> M<span class="small">ILL</span> C<span class="small">ITY</span></span></p>
<p class="toc"><span href="#/Part4#S9" title="Link target outside of Sample">By Means Unknown</span></p>
<p class="toc"><span href="#/Part4#S10" title="Link target outside of Sample">The Family that Slays Together</span></p>
<p class="toc"><span href="#/Part4#S11" title="Link target outside of Sample">The Streetcar Strike</span></p>
<p class="toc"><span href="#/Part4#S12" title="Link target outside of Sample">Midnight Assassination</span></p>
<p class="toc1"><span href="#/Notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?c7679366